import { observer } from 'mobx-react';
import React from 'react';
import { AccountReturnParams } from '../pages/AccountPage';
import { Accordion } from '@teliaee/design-system';
import EmailAccordionItem, { EMAIL_ACCORDION_ITEM_ID, EMAIL_ACCORDION_ITEM_NOTICES } from './EmailAccordionItem';
import PasskeyAccordionItem from './PasskeyAccordionItem';
import AddEmailModal from './AddEmailModal';
import ChangePasswordModal from '../email/ChangePasswordModal';
import MergeLoginModal from './MergeLoginModal';
import EmailMergeConfirmModal from './EmailMergeConfirmModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import useStores from '../stores/UseStores';

interface IAccountLoginMethodsProps {
  returnParams: AccountReturnParams;
}

const AccountLoginMethods = observer((props: IAccountLoginMethodsProps): React.JSX.Element => {
  const { returnParams } = props;
  const {
    accountInfoStore: { showPasskey },
    uiStore,
  } = useStores();

  const getEmailModals = () => {
    return (
      <>
        <AddEmailModal />
        <ChangePasswordModal />
        <MergeLoginModal />
        <EmailMergeConfirmModal />
        <ForgotPasswordModal />
      </>
    );
  };

  const resolveDefaultOpenAccordionItem = (): [string] | undefined => {
    return uiStore.hasNoticeOfKind(EMAIL_ACCORDION_ITEM_NOTICES) ? [EMAIL_ACCORDION_ITEM_ID] : undefined;
  };

  return (
    <>
      <Accordion type="card" size="large" defaultOpenItem={resolveDefaultOpenAccordionItem()}>
        {showPasskey && <PasskeyAccordionItem />}
        <EmailAccordionItem returnParams={returnParams} />
      </Accordion>
      {getEmailModals()}
    </>
  );
});

export default AccountLoginMethods;
